export enum GuessConfirmed {
    No = -1,
    Unknown = 0,
    Yes = 1
}